import { Discount } from '../models/discount';

/**
 * Map to discount model from dto.
 * @param {object} dto Dto to map.
 * @returns {Discount}
 */
function fromDto(dto) {
  return new Discount({
    id: dto.id,
    code: dto.code,
    packageId: dto.package_id,
    amountPerUnit: dto.amount_per_unit,
    amount: dto.amount,
    appliedQuantity: dto.applied_qty,
  });
}

export const discountMapper = {
  fromDto,
};
